'use client';

import { styled } from '@mui/material';

import { Announcement, Autorenew } from '../../../../icons';

export const TableMobileErrorContainer = styled('div')(({ theme }) => ({
  width: '100%',
  height: 104,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(4, 4, 3, 4),
  borderRadius: theme.spacing(4),
  background: theme.palette.surface2,
}));

export const TableMobileErrorTitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const TableMobileErrorWarnIcon = styled(Announcement)(({ theme }) => ({
  width: theme.spacing(6),
  height: theme.spacing(6),
  color: theme.palette.yellow[700],
}));

export const TableMobileErrorRefreshIcon = styled(Autorenew)(({ theme }) => ({
  width: theme.spacing(6),
  height: theme.spacing(6),
  color: theme.palette.blue[700],
}));
